import Constants from "./constants";

export default {
  ERROR_VALIDATION: "Error(s)",
  INVALID_IDENTIFIER: "Invalid ",
  INVALID_TXN_TYPE: "Select a Tran. Group",
  INVALID_START_DATE: "Invalid Start Date",
  INVALID_END_DATE: "Invalid End Date",
  INVALID_DATE_RANGE: `Invalid date range. Max. of ${Constants.MAX_DATE_RANGE_DAYS +
    1} day(s).`,
  INVALID_REQUESTED_AMOUNT: "Invalid Requested Amount",
  INVALID_REASON_CODE: "Select Reason",
  INVALID_DOMAIN: "Invalid Domain",
  INVALID_DISPUTE_AMOUNT_TYPE: "Invalid Dispute Amount Type",
  INVALID_DISPUTE_CATEGORY: "Select Dispute Category",
  INVALID_CODE: "Invalid Code",
  INVALID_CODES: "Invalid Codes",
  INVALID_NAME: "Invalid Name",
  INVALID_CHANNEL: "Select a Channel",
  INVALID_STORE: "Invalid Store",
  INVALID_CUSTOMER_REFERENCE_FIELD: "Invalid Customer Reference Parameter",
  INVALID_REQUIRED: "required",

  ERROR_TRANSACTIONS_SEARCH: "Error fetching transactions",
  ERROR_TRANSACTION_SEARCH: "Error fetching transaction",
  ERROR_TRANSACTIONS_SEARCH_TITLE: "Could not get Transactions",

  ERROR_TRANSACTION_FETCH: "Error fetching transaction",

  ERROR_TRANSACTION_GROUPS: "Could not fetch transaction groups",
  ERROR_TRANSACTION_TYPES: "Could not fetch transaction types",
  ERROR_TRANSACTION_STORES: "Could not fetch transaction stores",

  ERROR_DISPUTES_SEARCH: "Error fetching disputes",
  ERROR_DISPUTES_SEARCH_TITLE: "Could not get disputes",
  ERROR_DISPUTE_TRANSACTION_FETCH: "Error fetching transaction",

  ERROR_DISPUTE_FETCH_TITLE: "Could not get dispute",
  ERROR_DISPUTE_REGION: "Could not get dispute regions",
  ERROR_DISPUTE_CATEGORIES: "Could not get dispute categories",
  ERROR_DISPUTE_SETTLEMENTS_TITLE: "Could not get settlements",

  ERROR_REASON_CODES: "Could not get reason codes",
  ERROR_TRANSACTION_TIMELINES: "Could not get transaction timelines",
  ERROR_MERCHANT_DISPUTANTS: "Could not get merchant disputants",

  ERROR_COUNTRIES: "Could not get countries",

  SUCCESS_DISPUTE_CREATION: "Dispute successfully created",
  ERROR_DISPUTE_CREATION: "Error Creating dispute",

  SUCCESS_DISPUTE_ACTION: "Action Successful",
  ERROR_DISPUTE_ACTION: "Could not perform Action",
  SUCCESS_TRANSACTION_TIMELINE_DELETE:
    "Transaction Timeline  successfully  deleted",
  SUCCESS_MERCHANT_DISPUTANT_CREATED:
    "Merchant Disputant  successfully  created",
  SUCCESS_MERCHANT_DISPUTANT_DELETE:
    "Merchant Disputant  successfully  deleted",
  SUCCESS_DISPUTE_TIMELINE_DELETE: "Dispute Timeline successfully  deleted",

  SUCCESS_DISPUTE_BATCH_UPLOAD: "Batch uploaded successfully",
  ERROR_DISPUTE_BATCH_UPLOAD: "Error uploading batch file",

  ERROR_SCRIPT_UPDATE: "Error updating script",

  ERROR_REASON_CODE_UPDATE: "Error creating/updating reason code",
  ERROR_TRANSACTION_TYPE_UPDATE: "Error creating/updating transaction type",
  ERROR_TRANSACTION_TIMELINES_UPDATE: "Error creating/updating timelines",
  ERROR_TRANSACTION_TIMELINES_DELETE: "Error deleting transaction timelines",
  ERROR_MERCHANT_DISPUTANT_CREATE: "Error creating merchant disputant",
  ERROR_MERCHANT_DISPUTANT_DELETE: "Error deleting merchant disputant",
  ERROR_DISPUTE_TIMELINES: "Error fetching dispute timelines",

  ERROR_DISPUTE_REGION_UPDATE: "Error creating/updating dispute region",
  ERROR_TRANSACTION_GROUP_UPDATE: "Error creating/updating transaction group",

  ERROR_SCRIPTS: "Error fetching scripts",

  ERROR_FILE_TOO_LARGE_TITLE: "Too Large",
  ERROR_FILE_TOO_LARGE: "Selected file too large. Maximum file size is ",

  ERROR_EVIDENCE_ADD: "Could not add evidence ",

  ERROR_MAXIMUM_EVIDENCE_UPLOAD_COUNT:
    "Maximum number of evidence files exceeded",
  ERROR_EVIDENCE_INVALID_FILE_TYPE_TITLE: "Bad file format",

  ERROR_EVIDENCE_INVALID_FILE_TYPE:
    "Unsupported file format. Only JPEG and PNG formats are supported ",
  ERROR_EVIDENCE_NO_FILE_SELECTED: "No files selected",
  ERROR_EVIDENCE_REQUIRED:
    "Evidence required to perform action on Dispute. Please attach evidence.",
  ERROR_COMMENT_REQUIRED:
    "Comment required to perform action on Dispute. Please add a comment.",

  ERROR_BATCH_INVALID_FILE_TYPE_TITLE: "Bad file format",
  ERROR_BATCH_INVALID_FILE_TYPE:
    "Unsupported file format. Only Excel Workbooks(.xls and .xlsx) formats are supported ",
  ERROR_BATCH_NO_FILE_SELECTED: "No files selected",

  ERROR_SETTLEMENT_REQUEST_STATUSES:
    "Could not fetch settlement request statuses",

  ACTION_NEVER_ASK: "Never ask for this action again.",
  ACTION_WARNING: "Are you sure you want to perform the action",

  NO_PERMISSIONS: "You don't have permissions on this app.",
  LOAD_PERMISSIONS_ERROR: "Error loading user permissions",

  SESSION_TIMEOUT: "Session timed out. Redirecting to login page",

  SUCCESS_SETTLEMENT_REQUEST_PROCESSED:
    "Successfully processed settlement request.",
  SUCCESS_SETTLEMENT_REQUEST_MAPPED:
    "Successfully mapped settlement request participants",
  SUCCESS_SETTLEMENT_REQUEST_CANCELED:
    "Successfully canceled settlement request",

  ERROR_SETTLEMENT_REQUESTS: "Error loading settlement requests.",
  ERROR_SETTLEMENT_REQUEST_PROCESSED: "Error processing settlement request.",
  ERROR_SETTLEMENT_REQUEST_MAPPED:
    "Error mapping settlement request participants",
  ERROR_SETTLEMENT_REQUEST_CANCELED: "Error",
  ERROR_SETTLEMENT_REASON_REQUIRED:
    "Reason required to cancel request. Please provide a reason.",

  ERROR_SETTLEMENT_RULES_LABEL: "Error fetching settlement rules label",
  ERROR_SETTLEMENT_RULES: "Error fetching settlement rules",
  ERROR_SETTLEMENT_RULES_UPDATE: "Error creating/updating settlement rules",
  ERROR_SETTLEMENT_RULES_DELETE: "Error deleting settlement rule",

  ERROR_REPORTS: "Error fetching reports",
  ERROR_GENERATING_REPORTS: "Error generating report",

  ERROR_SETTLEMENT_REPORTS: "Error fetching settlement reports",
  ERROR_GENERATING_SETTLEMENT_REPORTS: "Error generating settlement reports",

  SUCCESS_SETTLEMENT_RULE_DELETE: "Settlement Rule successfully  deleted",

  SUCCESS_CASE_INITIATION: "Case Initiation submitted successfully",
  ERROR_CASE_INITIATION: "Case Initiation submission unsuccessful",

  SUCCESS_CASE_UPDATE: "Case update submitted successfully",
  ERROR_CASE_UPDATE: "Case update submission unsuccessful",

  ERROR_DUPLICATE_TRANSACTIONS: "Could not get duplicate transactions",

  SUCCESS_CASE_NOTE: "Case Note added successfully",
  ERROR_CASE_NOTE: "Case Note not added successfully",

  ERROR_CASES_SEARCH: "Error fetching cases",
  ERROR_CASES: "Error fetching case details",
  ERROR_CASE_REQUESTS: "Error fetching case requests",
  ERROR_CASE_DOCUMENTS: "Error fetching documents",

  SUCCESS_CASE_DOCUMENT: "Succesfully added document to case",
  SUCCESS_CANCEL_CASE_REQUEST: "Case Request Cancelled",
  ERROR_CASE_DOCUMENT: "Could not add document to case",
  ERROR_DOWNLOADCASE_DOCUMENT: "Could not download case document",
  ERROR_CANCELLING_CASE_REQUEST: "Could not cancel case request"

};



// WEBPACK FOOTER //
// ./src/configurations/messages.js